export default __webpack_public_path__ + "static/media/shop.031d0634.svg";